import { render } from "./HeaderNavigation.vue?vue&type=template&id=3485b288&scoped=true&ts=true"
import script from "./HeaderNavigation.vue?vue&type=script&lang=ts"
export * from "./HeaderNavigation.vue?vue&type=script&lang=ts"

import "./HeaderNavigation.vue?vue&type=style&index=0&id=3485b288&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3485b288"]])

export default __exports__